import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSubmissions, updateSubmission } from '@/store/slices/submissionSlice'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { LoadingSpinner } from '@/components/ui/loading-spinner'

const VisitorAssignments = () => {
  const dispatch = useDispatch()
  const { submissions, loading } = useSelector(state => state.submissions)
  const { user } = useSelector(state => state.auth)

  useEffect(() => {
    dispatch(fetchSubmissions())
  }, [dispatch])

  const handleVerify = (submissionId) => {
    dispatch(updateSubmission({
      submissionId,
      data: { status: 'verified' }
    }))
  }

  const getStatusBadgeVariant = (status) => {
    switch (status) {
      case 'verified': return 'default'
      case 'rejected': return 'destructive'
      case 'assigned': return 'secondary'
      case 'processing': return 'outline'
      default: return 'outline'
    }
  }

  const assignedSubmissions = submissions.filter(
    submission => submission.visitor_id === user.id
  )

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">My Assignments</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Assigned Submissions</CardTitle>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="flex justify-center py-8">
              <LoadingSpinner />
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Form</TableHead>
                  <TableHead>User</TableHead>
                  <TableHead>Submitted At</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {assignedSubmissions.map((submission) => (
                  <TableRow key={submission.id}>
                    <TableCell className="font-medium">{submission.form_name}</TableCell>
                    <TableCell>{submission.user_name}</TableCell>
                    <TableCell>{new Date(submission.created_at).toLocaleDateString()}</TableCell>
                    <TableCell>
                      <Badge variant={getStatusBadgeVariant(submission.status)}>
                        {submission.status}
                      </Badge>
                    </TableCell>
                    <TableCell>
                      <div className="flex space-x-2">
                        <Button 
                          variant="outline" 
                          size="sm"
                          onClick={() => handleVerify(submission.id)}
                        >
                          Verify
                        </Button>
                        <Button 
                          variant="outline" 
                          size="sm"
                        >
                          View Details
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}

          {assignedSubmissions.length === 0 && !loading && (
            <div className="text-center text-muted-foreground py-8">
              No assignments found.
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export default VisitorAssignments